import apiClient from "../apiClient";

import type { UserInfo, UserRole, UserToken } from "#/entity";

/** GET /users/me — schema: internal_controllers.UserResponse */
export interface UserMeResponse {
	active?: boolean;
	/** 显示名称 */
	displayName?: string;
	email?: string;
	firebaseUid?: string;
	/** 保留向后兼容 */
	firstName?: string;
	id?: number;
	inviteCode?: string;
	/** KYC等级：0-未认证，1-已认证 */
	kycLevel?: number;
	/** KYC状态：NOT_SUBMITTED, PENDING, PASSED, REJECTED */
	kycStatus?: string;
	/** 保留向后兼容 */
	lastName?: string;
	profilePhoto?: string;
	/** 用户角色：user, merchant, admin */
	role?: string;
}

export function mapUserMeResponseToUserInfo(res: UserMeResponse): UserInfo {
	const legacyName = [res.firstName, res.lastName].filter(Boolean).join(" ").trim();
	const username =
		res.displayName?.trim() ||
		legacyName ||
		(res.email ? res.email.split("@")[0] : "") ||
		"";
	const id = res.id !== undefined ? String(res.id) : "";
	const role = res.role as UserRole | undefined;
	return {
		id,
		email: res.email ?? "",
		username,
		avatar: res.profilePhoto,
		role,
		roles: role ? [role] : undefined,
		active: res.active,
		displayName: res.displayName,
		firebaseUid: res.firebaseUid,
		firstName: res.firstName,
		lastName: res.lastName,
		inviteCode: res.inviteCode,
		kycLevel: res.kycLevel,
		kycStatus: res.kycStatus,
		profilePhoto: res.profilePhoto,
	};
}

export interface SignInReq {
	username: string;
	password: string;
}

export interface SignUpReq extends SignInReq {
	email: string;
}
export type SignInRes = UserToken & { user: UserInfo };

export enum UserApi {
	SignIn = "/auth/signin",
	SignUp = "/auth/signup",
	Logout = "/auth/logout",
	Refresh = "/auth/refresh",
	User = "/user",
	CurrentUser = "/users/me",
}

const signin = (data: SignInReq) => apiClient.post<SignInRes>({ url: UserApi.SignIn, data });
const signup = (data: SignUpReq) => apiClient.post<SignInRes>({ url: UserApi.SignUp, data });
const logout = () => apiClient.get({ url: UserApi.Logout });
const findById = (id: string) => apiClient.get<UserInfo[]>({ url: `${UserApi.User}/${id}` });
const getCurrentUser = () => apiClient.get<UserMeResponse>({ url: UserApi.CurrentUser });

export default {
	signin,
	signup,
	findById,
	logout,
	getCurrentUser,
};
